import React from 'react'
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { userSelector } from 'slices/userSlice';
import AppointmentDetails from 'views/appointmentDetails/appointmentDetails';
import InterpreterAppointmentDetails from 'views/appointmentDetails/InterpreterAppointmentDetails';
import InterpreterJoinRoom from 'views/appointmentDetails/InterpreterJoinRoom';
import FeedbackForm from 'views/FeedBackForm';
import ForgotPassword from 'views/ForgotPassword';
import AppointmentConfirmation from 'views/AppointmentConfirmation';

import Login from "views/login";
import Register from "views/register";
import RequesterJoinRoom from 'views/RequesterJoinRoom/RequesterJoinRoom';
import ResetPassword from 'views/ResetPassword';
import InterviewInvite from 'views/interview-invite';
import InvoiceIssueReport from 'views/InvoiceIssueReport';
import VerifyEmailPending from 'views/VerifyEmailPending';
import VerifyEmail from 'views/VerifyEmail';
export const AuthRoutes = () => {
    const { pathname } = useLocation()
    const { isAuthenticated } = useSelector(userSelector);

    // Redirect to admin if already authenticated
    // if (isAuthenticated) {
    //     return <Navigate to="/admin" replace />;
    // }
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/feedback" element={<FeedbackForm />} />
            {/* <Route path="/register" element={<Register />} /> */}
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email-pending" element={<VerifyEmailPending />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            {/* Catch-all for unauthenticated users */}
            <Route path="/appointment-details" element={<AppointmentDetails />} />
             <Route path="/appointment-details/view/requester/join-room-call" element={<RequesterJoinRoom />} />
            <Route path="/interpreter/appointment-details" element={<InterpreterAppointmentDetails />} />
            <Route path="/interpreter/appointment-details/join-room-call" element={<InterpreterJoinRoom />} />
            <Route path="/confirmation" element={<AppointmentConfirmation />} />
            <Route path="/invoice-issue" element={<InvoiceIssueReport />} />
            <Route path="/interview-invite" element={<InterviewInvite />} />
            {!["/interview-invite", "/verify-email-pending", "/verify-email"].includes(pathname) && <Route path={"*"} element={<Navigate to="/login" replace />} />}
        </Routes>
    )
}
